import { Box, IconButton, Link, Paper, Stack, TextField } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";

interface Props {
    block: LinkBlock;
    onChange: (content: any) => void;
    onDelete: () => void;
}

const LinkBlockEditor = ({ block, onChange, onDelete }: Props) => {
    return (
        <Paper sx={{ p: 2, mb: 2 }}>
            <Stack direction="row" spacing={1} alignItems="flex-start">
                <IconButton size="small" sx={{ cursor: "grab" }}>
                    <DragIndicatorIcon />
                </IconButton>
                <Box flex={1}>
                    <Stack spacing={2}>
                        <TextField
                            label="Link Text"
                            value={block.content.text}
                            onChange={(e) =>
                                onChange({
                                    ...block.content,
                                    text: e.target.value,
                                })
                            }
                            fullWidth
                            size="small"
                        />
                        <TextField
                            label="URL"
                            value={block.content.url}
                            onChange={(e) =>
                                onChange({
                                    ...block.content,
                                    url: e.target.value,
                                })
                            }
                            fullWidth
                            size="small"
                        />
                        <Box>
                            <Link href={block.content.url} target="_blank" rel="noopener">
                                {block.content.text || "Link Preview"}
                            </Link>
                        </Box>
                    </Stack>
                </Box>
                <IconButton size="small" onClick={onDelete} color="error">
                    <DeleteIcon />
                </IconButton>
            </Stack>
        </Paper>
    );
};

export default LinkBlockEditor;
